const AUTH_SESSION_STORAGE_KEY = 'cleverlink.authSession'

export interface AuthSession {
  access_token: string
  token_type: string
  roles: Array<string>
  user_id: number
  email: string
  first_name: string
  last_name: string
}

export const getAuthSession = (): AuthSession | null => {
  try {
    const raw = localStorage.getItem(AUTH_SESSION_STORAGE_KEY)
    return raw ? (JSON.parse(raw) as AuthSession) : null
  } catch {
    return null
  }
}

export const setAuthSession = (session: AuthSession): void => {
  localStorage.setItem(AUTH_SESSION_STORAGE_KEY, JSON.stringify(session))
}

export const clearAuthSession = (): void => {
  localStorage.removeItem(AUTH_SESSION_STORAGE_KEY)
}

export const getAuthToken = (): string | null =>
  getAuthSession()?.access_token ?? null

export const isTokenExpired = (): boolean => {
  const token = getAuthToken()

  if (!token) return true

  try {
    const parts = token.split('.')

    if (parts.length < 2) return true

    const payload = JSON.parse(atob(parts[1]))
    const expiresAt = (payload.exp ?? 0) * 1000

    return Date.now() > expiresAt
  } catch {
    return true
  }
}
